export default "__VITE_ASSET__fwxajeDw__"